import { equals } from 'ramda';

import { justChangeJsonQuery } from './justChangeJsonQuery';
import { dealTypeFromJsonQuery, FDealType, getDateRangeValue, TJsonQuery } from '../../../../packages/JsonQuery';
import { IJsonQuery } from '../../../../packages/api-models/common/json_query';
import { setAwaitingGeoFocus } from '../../../Map/actions/geoFocus';
import { trackPageview } from '../../../Map/tracking/trackPageview';
import { IFiltersUpdatedEventDetail } from '../../types/desktopFiltersMicrofrontend';
import { TThunkAction } from '../../types/redux';
import { getTrackingUser } from '../../utils/analytics/getTrackingUser';
import { sendSerpFilterAppliedUxfbEvent } from '../../uxfb';
import { applyGeoChange } from '../applyGeoChange';
import { closeOfferPreview } from '../closeOfferPreview/closeOfferPreview';
import { fetchHybridSearchData } from '../fetchHybridSearchData';

/** Проверяет, изменились ли гео-параметры в jsonQuery */
function isGeoChanged(current: IJsonQuery, next: IJsonQuery): boolean {
  return !equals(current.geo, next.geo) || !equals(current.region, next.region);
}

/**
 * Thunk для обработки события обновления фильтров из микрофронтенда.
 * По аналогии с handleApply из FiltersContainer:
 * устанавливает jsonQuery, обновляет карту и листинг.
 * При гео-изменениях дополнительно обновляет регион и зумит карту.
 */
export const applyMicrofrontendFilters =
  (detail: IFiltersUpdatedEventDetail): TThunkAction =>
  (dispatch, getState) => {
    const { jsonQuery, searchMeta } = detail;
    const state = getState();
    const currentJsonQuery = state.filters.jsonQuery as TJsonQuery;
    const currentDealType = dealTypeFromJsonQuery(currentJsonQuery);
    const nextDealType = dealTypeFromJsonQuery(jsonQuery as TJsonQuery);
    const redirectUrl = searchMeta?.mapUrl;
    const hasNoDates = !getDateRangeValue('dates')(currentJsonQuery);
    const user = getTrackingUser(state);

    dispatch(
      sendSerpFilterAppliedUxfbEvent({
        jsonQuery,
        deviceType: 'desktop',
      }),
    );

    if (hasNoDates) {
      trackPageview({ jsonQuery, user });
    }
    if (redirectUrl && currentDealType === FDealType.RentDaily && nextDealType !== FDealType.RentDaily) {
      window.location.href = redirectUrl;

      return;
    }

    // Новая выдача по фильтрам закрывает превью: в нём данные прошлых фильтров (см. IPreviewOffersState).
    dispatch(closeOfferPreview());

    const geoChanged = isGeoChanged(currentJsonQuery, jsonQuery);

    dispatch(justChangeJsonQuery({ nextJsonQuery: jsonQuery }));

    if (geoChanged) {
      dispatch(applyGeoChange({ jsonQuery: jsonQuery as TJsonQuery }));

      return;
    }

    // Сбрасываем флаг ожидания гео-фокуса, залипший с прошлой гео-смены,
    // если её фокус не применился (например, setBounds был отклонён).
    dispatch(setAwaitingGeoFocus(false));
    dispatch(
      fetchHybridSearchData({
        updateBounds: false,
        deviceType: 'desktop',
      }),
    );
  };
